import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Send } from 'lucide-react';
import { FileUpload } from '@/components/sendEvent/FileUpload';
import { TypeNiche } from '@/types';
import { Skeleton } from '@/components/ui/skeleton';

interface EventFormProps {
  userName: string;
  email: string;
  pixelId: string;
  token: string;
  file: File | null;
  typeNiche: string;
  listTypeNiche: TypeNiche[];
  onTypeNicheChange: (value: string) => void;
  onUserNameChange: (value: string) => void;
  onEmailChange: (value: string) => void;
  onPixelIdChange: (value: string) => void;
  onTokenChange: (value: string) => void;
  onFileSelect: (file: File | null) => void;
  onSubmit: () => void;
  isSubmitting: boolean;
  isValid: boolean;
  isLoadingNiches: boolean;
}

export const EventForm = ({
  userName,
  email,
  pixelId,
  token,
  file,
  onFileSelect,
  isValid,
  typeNiche,
  listTypeNiche,
  onTypeNicheChange,
  onUserNameChange,
  onEmailChange,
  onPixelIdChange,
  onSubmit,
  onTokenChange,
  isSubmitting,
  isLoadingNiches,
}: EventFormProps) => {
  return (
    <Card className="shadow-soft">
      <CardHeader>
        <CardTitle>Configuração do Evento</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-2">
          <div className="space-y-2">
            <Label htmlFor="eventUserName">Nome do Usuário</Label>
            <Input
              id="eventNomeCustom"
              autoComplete="off"
              placeholder="Insira o Nome do Usuário"
              value={userName}
              onChange={(e) => onUserNameChange(e.target.value)}
              disabled={isSubmitting}
              readOnly
              onFocus={(e) => (e.target.readOnly = false)}
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="eventUserEmail">Email do Usuário</Label>
            <Input
              id="eventEmailCustom"
              type="email"
              autoComplete="off"
              placeholder="Insira o Email do Usuário"
              value={email}
              onChange={(e) => onEmailChange(e.target.value)}
              disabled={isSubmitting}
              readOnly
              onFocus={(e) => (e.target.readOnly = false)}
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="eventPixelId">Pixel ID</Label>
            <Input
              id="eventPixelCustom"
              autoComplete="off"
              placeholder="Insira o Pixel ID"
              value={pixelId}
              onChange={(e) => onPixelIdChange(e.target.value)}
              disabled={isSubmitting}
              readOnly
              onFocus={(e) => (e.target.readOnly = false)}
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="eventToken">Facebook Access Token</Label>
            <Input
              id="eventCustomTok"
              type="password"
              autoComplete="off"
              placeholder="Insira o Access Token"
              value={token}
              onChange={(e) => onTokenChange(e.target.value)}
              disabled={isSubmitting}
              readOnly
              onFocus={(e) => (e.target.readOnly = false)}
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="eventType">Tipo de Nicho</Label>
            {isLoadingNiches ? (
              <Skeleton className="h-10 w-full" />
            ) : (
              <Select value={typeNiche || 'Selecione um Nicho'} onValueChange={onTypeNicheChange}>
                <SelectTrigger id="typeNiche" disabled={isSubmitting}>
                  <SelectValue placeholder="Selecione o nicho" />
                </SelectTrigger>
                <SelectContent>
                  {listTypeNiche.map((item) => (
                    <SelectItem key={item.id} value={item.name}>
                      {item.name}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            )}
          </div>
          <div className="space-y-2  mt-5">
            <Label />
            <p className="text-xs text-muted-foreground  mt-3 ml-3">
              OBS: Confirme que o Pixel ID e o Facebook Access Token estejam corretos antes de
              enviar o Evento, para garantir que o evento seja registrado corretamente!
            </p>
          </div>
        </div>
        {typeNiche === 'Custom' && <FileUpload selectedFile={file} onFileSelect={onFileSelect} />}
        <Button onClick={onSubmit} disabled={!isValid || isSubmitting} className="w-full" size="lg">
          <Send className="mr-2 h-4 w-4" />
          {isSubmitting ? 'Processando...' : 'Enviar Eventos'}
        </Button>
      </CardContent>
    </Card>
  );
};
